import { useCallback } from 'react';

import axios, { AxiosError, AxiosResponse } from 'axios';
import i18n from 'i18next';
import { useMutation, useQueryClient } from 'react-query';

import { showSnackbar } from '../components/shared';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import showError from '../components/shared/showError';

import { UseCreateResource } from './useCreateResource';

export interface UseUpdateResource extends UseCreateResource {
  id: string | number;
}

export const useUpdateResource = ({
  url,
  id,
  invalidateQueryKey,
  message
}: UseUpdateResource) => {
  const update = useCallback(
    (data) => axios.put(`${url}${id ? '/' + id : ''}`, data),
    [url, id]
  );

  const queryClient = useQueryClient();

  return useMutation<AxiosResponse, AxiosError, any>(update, {
    onSuccess: async (response) => {
      if (invalidateQueryKey) {
        await queryClient.invalidateQueries({
          queryKey: invalidateQueryKey
        });
      }
      showSnackbar({
        severity: 'success',
        message: message?.success ?? i18n.t('changesSaved')
      });
      return response;
    },
    onError: (error) => {
      message?.error ? showErrorSnackbar(message.error) : showError(error);
    }
  });
};
